import React from 'react'
import Manager from 'tyan/public/components/Manager'
import InstrumentAdjustDetail from './InstrumentAdjustDetail'
import InstrumentDetail from '../InstrumentDetail'

Ext.require('Ext.Toast')

const config = {
    tabs: {
        '当月计划': {
            buttons: [
            ],
            export: true,
            exportColumns: [
                { _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true, },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 200, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 150, },
            ],
            columns: [
                {
                    _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true,
                    tools: [{
                        _tool: '', btnName: '查_看2', zone: 'end',
                        handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
                    }]
                },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 200, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 150, },
                { _: '', name: 'InstrumentID', field: 'Instrument.InstrumentID' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentAdjustDetail {...props} id={data.id} />),
        },
        '全部计划': {
            buttons: [
            ],
            export: true,
            exportColumns: [
                { _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true, },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 200, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 150, },
            ],
            columns: [
                {
                    _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true,
                    tools: [{
                        _tool: '', btnName: '查_看2', zone: 'end',
                        handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
                    }]
                },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 200, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 150, },
                { _: '', name: 'InstrumentID', field: 'Instrument.InstrumentID' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentAdjustDetail {...props} id={data.id} />),
        },
        '已完成': {
            buttons: [
            ],
            export: true,
            exportColumns: [
                { _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true, },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 200, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 150, },
            ],
            columns: [
                {
                    _text: '设备编号', field: 'Instrument.InstrumentNumber', minWidth: 150, locked: false, search: true,
                    tools: [{
                        _tool: '', btnName: '查_看2', zone: 'end',
                        handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
                    }]
                },
                { _text: '设备名称', field: 'Instrument.InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _text: '设备归属', field: 'Instrument._FirstCatalogName', minWidth: 150, },
                { _text: '型号', field: 'Instrument.F1', minWidth: 150, filter: true, },
                { _text: '计量内容', field: 'OperationPara', minWidth: 200, filter: true, },
                { _text: '技术要求', field: '_TechnicalRequirement', minWidth: 200, flex: 1, },
                { _text: '计划日期', field: '_PlannedDate', minWidth: 120, },
                { _text: '计量周期(月)', field: '_ParaCycle', minWidth: 110, },
                { _text: '完成日期', field: '_RealDate', minWidth: 120, },
                { _text: '计量单位', field: 'OperationSupplier', minWidth: 150, filter: true, },
                { _text: '计量结果', field: 'OperationResult', minWidth: 120, filter: true, },
                { _: '', name: 'InstrumentID', field: 'Instrument.InstrumentID' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentAdjustDetail {...props} id={data.id} readOnly={true} canSave={true} canDel={true} />),
        },
    },
}

export default props => <Manager {...props} config={config} />